import { render, staticRenderFns } from "./AnswerColumns1.vue?vue&type=template&id=79eb0e35&scoped=true&"
import script from "./AnswerColumns1.vue?vue&type=script&lang=js&"
export * from "./AnswerColumns1.vue?vue&type=script&lang=js&"
import style0 from "./AnswerColumns1.vue?vue&type=style&index=0&id=79eb0e35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eb0e35",
  null
  
)

export default component.exports